import React from 'react';

/* ──────────────────────────────────────────────
 *  CountryFlag — Reusable flag image. Resolves the
 *  SVG from a configurable base URL so it works in
 *  every host context:
 *    • frontend-web → same-origin "/image/flags"
 *    • embedded widget → CDN base (next to booking.js)
 *  Asset layout: `${baseUrl}/${size}/${CODE}.svg`
 * ────────────────────────────────────────────── */

export const DEFAULT_FLAG_BASE_URL = '/image/flags';

export type CountryFlagSize = 's' | 'm' | 'l';

interface CountryFlagProps {
  /** ISO 3166-1 alpha-2 country code (case-insensitive) */
  code: string;
  size?: CountryFlagSize;
  /** Base URL where flag SVGs are hosted. Defaults to same-origin assets. */
  baseUrl?: string;
  className?: string;
}

export function CountryFlag({
  code,
  size = 's',
  baseUrl = DEFAULT_FLAG_BASE_URL,
  className,
}: CountryFlagProps): React.ReactElement {
  const normalized = code.toUpperCase();

  return (
    <img
      className={`bt-flag${className ? ` ${className}` : ''}`}
      src={`${baseUrl}/${size}/${normalized}.svg`}
      alt=""
      aria-hidden="true"
      width={22}
      height={16}
      loading="lazy"
      draggable={false}
    />
  );
}
